'use strict';

function LoanLiquidAdditionalPaymentAmount() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_MoneyController];

  this._submitted = false;

  this.init = function () {
    this._super();
  };

  this.initAllReady = function () {
    this._super();
  };

  this.initPage = function () {
    var _this = this;

    if (!this._checkAdditionalPaymentFlowEligibility()) {
      return;
    }

    this._form = $(this.node).find('form');
    this._form.on('submit', this._onSubmitForm.bind(this));
    this._setupLivechat();

    this.presenter.extendViewMap({
      'money.loans.loans[0].create_additional.date': {
        get: function get(val) {
          // Need to return a full date with year.
          return val ? moment(val).format('ddd, MMM D') : '';
        }
      }
    });

    this.presenter.addComputedVariable('next_regular_payment_amount', ['money.loans.loans[0].next_payments', 'money.loans.loans[0].additional_payment_maximum_date'], function (nextPayments, nextAvailablePaymentDate) {
      var amount = 0;
      nextAvailablePaymentDate = moment(nextAvailablePaymentDate);
      for (var i = 0; i < nextPayments.length; i++) {
        var regularPaymentDate = moment(nextPayments[i].date);
        if (nextAvailablePaymentDate.isSame(regularPaymentDate)) {
          amount = nextPayments[i].amount + nextPayments[i].protection_amount;
          break;
        }
      }
      return amount.toFixed(2);
    });

    this.presenter.addComputedVariable('total_payment_amount', ['money.loans.loans[0].create_additional.amount'], function (additionalAmount) {
      var regularPayment = _this.presenter._getComputedValue('next_regular_payment_amount');
      return +regularPayment + +additionalAmount;
    });

    var paymentInputs = $('#additional-payment-amount, #additional-payment-amount-alt');
    paymentInputs.on('keyup', function (e) {
      var newVal = +$(e.target).mogo().val();
      var curVal = +_this.presenter.getModelProperty('money.loans.loans[0].create_additional.amount');
      if (newVal !== curVal && !(newVal === 0 && isNaN(curVal))) {
        // Different value and not fresh input
        var val = $(e.target).mogo().val();
        _this.presenter.setModelProperty('money.loans.loans[0].create_additional.amount', val);
      }
    });
    paymentInputs.on('blur', this._validateForm.bind(this));
    paymentInputs.on('focus', function () {
      var paymentField = null;
      if (_this._liquidLoan.create_additional.selection === 'custom') {
        paymentField = $('#additional-payment-amount');
      } else {
        paymentField = $('#additional-payment-amount-alt');
      }

      if (paymentField.mogo()._state === -1) {
        paymentField.mogo().showErrorLabel();
      }
    });

    $('.loans__tray-loader').addClass('hide');
    $('.loans__content-wrapper').removeClass('hide');

    this._pushAnalytics();
  };

  this._onSubmitForm = function (e) {
    this._submitted = true;

    var result = this._validateForm(e);
    if (result) {
      var formAnalyticsID = this._form.data('analytics-id');
      this.analytics.pushEvent('form-submit', { FormID: [formAnalyticsID] });
      this._history.goToUrl(this.paths.loans.liquid.add_payment.additional.review);
    }
  };

  this._validateForm = function (e) {
    e.preventDefault();

    var paymentField = null;
    if (this._liquidLoan.create_additional.selection === 'custom') {
      paymentField = $('#additional-payment-amount');
    } else {
      paymentField = $('#additional-payment-amount-alt');
    }

    var amount = +this._liquidLoan.create_additional.amount;
    if (isNaN(amount) || amount <= 0) {
      this.presenter.setModelProperty('money.loans.loans[0].create_additional.amount', '0.00');
      paymentField.mogo().setErrorOnKeyword('default');
      if (this._submitted) {
        paymentField.mogo().showErrorLabel();
      } else {
        paymentField.mogo().hideErrorLabel();
        paymentField.mogo().showError();
      }
      this.analytics.pushEvent('form-errors', { FormErrors: ['amount'] });
      return false;
    }
    var principalRemaining = this._liquidLoan.principal.amount_remaining;
    var nextRegularPayments = 0;
    var nextPayments = this._liquidLoan.next_payments;
    var nextPaymentDate = moment(this._liquidLoan.create_additional.date);
    for (var i = 0; i < nextPayments.length; i++) {
      if (moment(nextPayments[i].date).isBefore(nextPaymentDate)) {
        nextRegularPayments = nextRegularPayments + nextPayments[i].amount + nextPayments[i].protection_amount;
      } else {
        nextRegularPayments = nextRegularPayments + nextPayments[i].amount + nextPayments[i].protection_amount;
        break;
      }
    }
    var difference = principalRemaining - nextRegularPayments;

    if (amount > difference) {
      paymentField.mogo().setErrorOnKeyword('maximum');
      $(paymentField.mogo().containerDiv).find('.fieldError strong').text('$' + difference.toFixed(2));
      if (this._submitted) {
        paymentField.mogo().showErrorLabel();
      } else {
        paymentField.mogo().hideErrorLabel();
        paymentField.mogo().showError();
      }
      this.analytics.pushEvent('form-errors', { FormErrors: ['amount'] });
      return false;
    }

    paymentField.mogo().hideError();
    return true;
  };

  this._pushAnalytics = function () {
    var _this2 = this;

    if (this._liquidLoan.create_additional.selection === 'custom') {
      this.analytics.pushEvent('virtual-page-view', { Page: [window.location.href + '/custom'] });
    } else {
      this.analytics.pushEvent('virtual-page-view', {
        Page: [window.location.href + '/next_available']
      });
    }
    $('.tray-modal-close').on('click', function () {
      _this2.analytics.forcePushEvent('form-abandoned', { FormAbandoned: ['amount'] });
    });
  };

  this._setupLivechat = function () {
    this._$chatBtn = $('.js--chat');
    this._liveChatComponent = $("[data-mogo-UI='LiveChat']");

    // Prevents LiveChat from creating another component IE LiveChat_1
    // Behavior: Hide Chatbubble unless they click a chat bubble CTA
    if (this._$chatBtn.length && !this._liveChatComponent.length) {
      this._$chatBtn.mogo().create('LiveChat', { presenter: this.presenter });
    } else {
      this._liveChatComponent.mogo().hideChatIfNotEngaged();
    }

    this._$chatBtn.on('click', function (e) {
      e.preventDefault();
      if (window.LC_API && window.LC_API.open_chat_window) window.LC_API.open_chat_window();
    });
  };

  this.destroy = function () {
    this.presenter.removeComputedVariable('next_regular_payment_amount');
    this.presenter.removeComputedVariable('total_payment_amount');

    this._super();
  };
}